import React from 'react';

const ArrowLeft = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
        <g fill="none" fill-rule="evenodd">
            <g stroke="#111">
                <g>
                    <path d="M5 5L0 10 5 15" transform="translate(-506.000000, -346.000000) translate(507.000000, 341.000000)" />
                </g>
            </g>
        </g>
    </svg>

)

export default ArrowLeft;